import { vendorTracks } from '../../../Constants/Data';
import * as Icons from '../../../Constants/Icons';

const VendorTrack = () => {

    function renderIcon(iconProp) {
        if (typeof iconProp === 'function') {
            const IconComponent = iconProp;
            return <IconComponent />;
        }
        const IconComponent = Icons[iconProp];
        return IconComponent ? <IconComponent /> : null;
    }

    return (
        <div className="w-full min-h-[calc(100vh-60px)] h-fit flex flex-col px-[20px] py-[32px] xs:px-[40px] xs:py-[40px] 1.5xl:px-[104px] 1.5xl:py-[64px]">
            <div className="w-full flex flex-col">
                <h3 className="w-full text-usersTitle text-[36px] 1.5xl:text-[60px] text-center text-usersTitle font-allroundgothic font-[600] mb-0">Three Distinct Tracks</h3>
                <p className="mt-[32px] 1.5xl:mt-[24px] 1.5xl:pr-[20px] text-[18px] text-left text-[#505050] font-proximanova mb-0" style={{ lineHeight: '1.35' }}>Vendors are enrolled in one of the following tracks, each designed to cater to your unique business needs while also allowing users to easily find and contact you on our marketplace.</p>
            </div>
            <div className="mt-[32px] xl:mt-[48px] w-full flex flex-col xl:grid xl:grid-cols-3 gap-[48px] xl:gap-[24px]">
                {vendorTracks.map((track, index) => (
                    <div key={index} className="w-full xl:rounded-lg xl:shadow-lg xl:px-[32px] xl:py-[32px] flex flex-col items-center">
                        <div className="w-fit h-fit rounded-full bg-[#9a016a] p-[20px]">
                            {renderIcon(track.icon)}
                        </div>
                        <h3 className="mt-[32px] 1.5xl:text-[30px] font-proxima-nova font-semibold text-[#9A016A] text-center">{track.title}</h3>
                        <p className="mt-[32px] 1.5xl:mt-[24px] 1.5xl:pr-[20px] text-[18px] text-[#505050] font-proximanova mb-0 whitespace-pre-line" style={{ lineHeight: '1.35' }}>{track.description}</p>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default VendorTrack;